<div class="rn-page">
  <div class="apikey__box">
    <h2 class="intro-line-1">API Keys</h2>

    @if (hasExistingKeys()) {
      @for (key of existingKeys; track key) {
        <rn-apikey-item [text]="key" [canDelete]="canDeleteApiKey" (delete)="promptDeleteApiKey($event)"></rn-apikey-item>
      }
    }

    <div class="apikey__create">
      @if (!hasExistingKeys()) {
        <p class="apikey__text">
          <em>No keys have been created.</em>
        </p>
      }
      @if (canCreateApiKey()) {
        <button class="btn btn-primary" (click)="createApiKey()">Create</button>
      } @else {
        <p class="apikey__text apikey__limit">
          <em>This client has the maximum of {{ maxApiKeys }} API keys. Delete a key to create a new one.</em>
        </p>
      }
    </div>
  </div>
</div>

<message-dialog #errorDialog></message-dialog>
<message-dialog #confirmDialog [showAffirm]="false" [showClose]="true">
  <div class="apikey-delete">
    <h3 class="apikey-delete__title">Delete API key {{ keyPendingDelete ? getKeyPrefix(keyPendingDelete) : '' }}…?</h3>
    <p class="apikey-delete__text">This action cannot be undone.</p>
    <p class="apikey-delete__text">Integrations using this key will stop working.</p>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <button class="btn btn-link" type="button" (click)="keyPendingDelete = null; confirmDialog.close()">
        Cancel
      </button>
      <button class="btn btn-primary ml-4" type="button" (click)="confirmDialog.close(); deleteApiKey()">
        Delete
        <span class="icon icon-right">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </span>
      </button>
    </div>
  </div>
</message-dialog>
